import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';

type WallpaperConfig = {
  clickThroughUrl: string;
  wallpaperImage: string | null;
  wallpaperHtml: string | null;
  stickyWallpaper: boolean;
  stickySkyscrapers: boolean;
  setNoRepeatBackground: boolean;
};

export const $wallpaperConfig = atom<WallpaperConfig>(
  AtomChannels.Podlet,
  AtomTopics.Cycle,
  {
    clickThroughUrl: '',
    wallpaperImage: '',
    wallpaperHtml: '',
    stickySkyscrapers: true,
    stickyWallpaper: false,
    setNoRepeatBackground: false
  }
);

export namespace $wallpaperConfig {
  export type Value = WallpaperConfig;
}
